import { useQuery } from "@tanstack/react-query"
import giftApis from "src/api/gifts"
import CommonContainer from "src/components/CommonContainer"
import { GIFT_EXCHANGE_HISTORY, GIFT_ORDER } from "src/constants/queryKeys"
import { useAuthContext, useDialog } from "src/hooks"
import GiftExchangeItem from "./GiftExchangeItem"
import { useMemo, useState } from "react"
import { GiftExchangeHistoryModel } from "src/types"
import QRCodeDialog from "../GiftExchange/QRCodeDialog"
import GiftExchangeDialog from "../GiftExchange/GiftExchangeDialog"
import GiftExchangeSuccessDialog from "../GiftExchange/GiftExchangeSuccessDialog"
import { Box } from "@mui/material"

const GiftExchangeHistory = () => {
  const { profile } = useAuthContext()
  const { data: transactions } = useQuery({
    queryKey: [GIFT_EXCHANGE_HISTORY],
    queryFn: () =>
      giftApis.getGiftExchangeHistory({
        customerPhone: profile?.Mobile || "",
        pageIndex: 0,
        pageSize: 100,
      }),
    enabled: !!profile?.Mobile,
  })

  const { data: giftOrdered } = useQuery({
    queryKey: [GIFT_ORDER],
    queryFn: () =>
      giftApis.getGiftOrder({
        customerPhone: profile?.Mobile || "",
        pageIndex: 0,
        pageSize: 100,
      }),
    enabled: !!profile?.Mobile,
  })

  const [currentData, setCurrentData] = useState<
    GiftExchangeHistoryModel | undefined
  >(undefined)
  const {
    open: openQrCode,
    onClose: onCloseQrCode,
    onOpen: onOpenQrCode,
  } = useDialog()

  const [openGiftExchangeDialog, setOpenGiftExchangeDialog] = useState(false)

  const onOpenGiftExchange = () => setOpenGiftExchangeDialog(true)
  const onCloseGiftExchange = () => setOpenGiftExchangeDialog(false)

  const concatData = useMemo(() => {
    let newData = [] as Array<GiftExchangeHistoryModel>
    if (giftOrdered && giftOrdered.length) {
      const transformGiftData = giftOrdered.map(x => ({
        ...x,
        IsOrder: true,
      })) as Array<GiftExchangeHistoryModel>
      newData = newData.concat(transformGiftData)
    }
    if (transactions && transactions.length) {
      newData = newData.concat(transactions || [])
    }

    return newData.sort((a, b) =>
      new Date(a.CreatedDate) > new Date(b.CreatedDate) ? -1 : 0
    )
  }, [transactions, giftOrdered])

  return (
    <CommonContainer
      bannerProps={{
        src: "/assets/images/lich_su_doi_qua_banner.png",
        alt: "lich_su_doi_qua",
      }}
    >
      <Box
        mt={4}
        width="100%"
        maxHeight={500}
        sx={{
          overflowY: "auto",
        }}
      >
        {concatData?.map((d, i) => (
          <GiftExchangeItem
            onOpenRecieveGift={() => {
              onOpenQrCode()
              setCurrentData(d)
            }}
            onOpenGiftExchange={() => {
              onOpenGiftExchange()
              setCurrentData(d)
            }}
            key={i}
            data={d}
            isLastItem={i === concatData.length - 1}
          />
        ))}
      </Box>
      {openQrCode && (
        <QRCodeDialog
          data={currentData}
          key={`qrCode-${currentData?.QrCode}`}
          open={openQrCode}
          onClose={() => {
            onCloseQrCode()
            setCurrentData(undefined)
          }}
        />
      )}
      {openGiftExchangeDialog && (
        <GiftExchangeDialog
          open={openGiftExchangeDialog}
          onClose={() => {
            onCloseGiftExchange()
            setCurrentData(undefined)
          }}
          key={`gift-exchange-${currentData?.OrderId}`}
          data={currentData}
        />
      )}
      <GiftExchangeSuccessDialog
        open={false}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClose={() => {}}
        // key={`gift-exchange-success-${data?.id}`}
      />
    </CommonContainer>
  )
}

export default GiftExchangeHistory
